import { render } from "./EatingRecord.vue?vue&type=template&id=7a7757e6&scoped=true&ts=true"
import script from "./EatingRecord.vue?vue&type=script&lang=ts"
export * from "./EatingRecord.vue?vue&type=script&lang=ts"

import "./EatingRecord.vue?vue&type=style&index=0&id=7a7757e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a7757e6"]])

export default __exports__